import dc from 'dc';

function directive(getSize, generateId, $window) {
    var worldJSON = require("../../../system/assets/world.json");
    return {
        link: function ($scope, element, attrs) {
            var size = getSize(element, 'geoChart');
            var width = size.width;
            var height = size.height;
            $scope.page.w = angular.element($window);
            let geom;
            // element[0].insertAdjacentHTML('beforebegin', spinnerHTML); // start spinner
            // element[0].parentNode.querySelector('.loader').setAttribute('style', 'height:'+(height/2)+'px; position:relative; margin:'+(height/2)+"px 0px -"+(height)+"px 0px;zoom:0.5; -moz-transform: scale(0.5);");

            var chartUid = false, uid, key;// because there is one instances of this directive per view, we can assign a uid directly to it
            var dimension, group, div = "#geochart", searchCategories; // set our default vairables
            $scope.$on('init', function (event, chart) {
                if (chart.id !== attrs.uid) { return }
                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') { return } // if its not in our dc object, ignore
                $scope.main.dataObjects[chart.key].launched = true;
                uid = chart.id;
                key = chart.key;

                dimension = $scope.main.dataObjects[key].dimension;
                group = $scope.main.dataObjects[key].group;
                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;
                if (typeof $scope.main.dataObjects[key].div !== 'undefined') {
                    div = "#"+$scope.main.dataObjects[key].div;
                }
                chartUid = generateId();
                geom = dc.geoChoroplethChart(div);

                var filter = true;
                var numberFormat = d3.format(".2f");
                //var dimension = crossfilterData.dimension(function (d) { return d.remote_country;});
                var cc = [];
                var domain = [];
                var Rainbow = require('../../../system/assets/scripts/rainbowvis.js');
                var rainbow = new Rainbow();
                var numberOfItems;
                function doColor() {
                    domain = [];
                    cc = [];
                    numberOfItems = 1;
                    var count = group.top(Infinity).length;
                    if (count > 0) {
                        var top = group.orderNatural(function (p) { return p.count; }).top(1);
                        numberOfItems = top[0].value+1;
                    }
                    rainbow.setNumberRange(0, numberOfItems);
                    rainbow.setSpectrum("#FF0000", "#CC0000", "#990000", "#660000", "#360000"); //red gradient version
                    // rainbow.setSpectrum("#808080", "#737373", "#666666", "#595959", "#4C4C4C"); //pure gray
                    for (var i = 1; i <= numberOfItems; i++) {
                        domain.push(i);
                        var hexColour = rainbow.colourAt(i);
                        cc.push('#' + hexColour);
                    }
                }
                doColor();

                function zoomed() {
                    d3.select(element[0]).select('svg g').attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
                }

                var projection = d3.geo.mercator().precision(0.1).scale(width / 2.6 / Math.PI).translate([width / 2, height / 1.4]);
                // var projection = d3.geo.mercator().precision(0.1).scale(width / 2.6 / Math.PI).translate([width / 2.1, width / 3.7]);
                var zoom = d3.behavior.zoom()
                    .translate([0,0])
                    .scale(1)
                    .scaleExtent([0.75, 3])
                    .on("zoom", zoomed);
                var svg = d3.select(div)
                    .attr("width", width)
                    .attr("height", height)
                    .call(zoom);
                geom
                    .dimension(dimension)
                    .group(group)
                    .projection(projection)
                    .width(width)
                    .height(height)
                    .colors(d3.scale.ordinal().domain(domain).range(cc))
                    .colorCalculator(function (d) { return d ? geom.colors()(d) : '#ccc'; })
                    .overlayGeoJson(worldJSON.features, "country", function (d) {
                        return d.properties.name;
                    })
                    .title(function (d) {if (typeof d.value === "undefined") {return d.key + ": "+"0"} return d.key + ": "+ Math.round(d.value * 100) / 100});
                geom.render();

                if (filter == true) {
                    geom.on("filtered", function (chart, value) {
                        var column, title;
                        for (let s in searchCategories) {
                            column = s;
                            title = searchCategories[s];
                            break;
                        }
                        $scope.main.filterItem(column, value, "include", title);
                    });
                }

                // set update functions
                $scope.$on('updatedData', function (event, id) {
                    if (id !== uid) { return } // only run when it sees its id has filteres

                    geom.filterAll();
                    doColor(); // sets the correct colors depending on new number of items
                    geom.dimension(dimension)
                        .group(group)
                        .colors(d3.scale.ordinal().domain(domain).range(cc))
                        .colorCalculator(function (d) { return d ? geom.colors()(d) : '#ccc'; })

                    // redraw geomap with new data
                    geom.redraw();
                });

                // var projection = d3.geo.mercator().precision(0.1).scale(width / 2.1 / Math.PI).translate([width / 2, width / 3]);
                // // var projection = d3.geo.mercator().precision(0.1).scale(width / 2.6 / Math.PI).translate([width / 2.1, width / 3.7]);
                // var zoom = d3.behavior.zoom()
                //     .translate([0,0])
                //     .scale(1)
                //     .scaleExtent([0.75, 3])
                //     .on("zoom", zoomed);
                // var svg = d3.select(div)
                //     .attr("width", width)
                //     .attr("height", height)
                //     .call(zoom);
                // geom
                //     .dimension(dimension)
                //     .group(group)
                //     .projection(projection)
                //     .width(width)
                //     .height(height)

                let resizeTimeout;
                $scope.page.w.bind('resize', function () {
                    if ( !resizeTimeout ) {
                        if (typeof geom !== "undefined") {
                            resizeTimeout = setTimeout(function () {
                                resizeTimeout = null;
                                size = getSize(element, 'geoChart');
                                width = size.width;
                                height = size.height;
                                projection = d3.geo.mercator().precision(0.1).scale(width / 2 / Math.PI).translate([width / 2, width / 3]);
                                geom
                                    .width(width)
                                    .height(height)
                                    .projection(projection);
                                    d3.select(element[0]).select('svg').attr('width', width).attr('height', height);
                                geom.redraw();
                            }, 250);
                        }
                    }
                });

            });
            $scope.$on('$destroy', function () {
                element.remove();
                geom = undefined;
                $scope.page.w = null;
            });
        }
    };
}

directive.$inject = ['getSize', 'generateId', '$window'];
module.exports = directive;



/** WEBPACK FOOTER **
 ** ./src/pages/directives/geochart/makegeochart.js
 **/